import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ZohoSupportBridgeService {
	private loadPromise: Promise<void>;

	private load(): Promise<void> {
		if (this.loadPromise) return this.loadPromise;
		this.loadPromise = new Promise((resolve, reject) => {
			const ready = () => {
				const zoho = (window as any).$zoho;
				if (!zoho?.salesiq) return reject(new Error('Live support is unavailable'));
				const previousReady = zoho.salesiq.ready;
				zoho.salesiq.ready = () => { if (previousReady) previousReady(); resolve(); };
			};
			const existing = document.querySelector<HTMLScriptElement>('script[src="assets/js/zoho-chat.js"]');
			if (existing) { ready(); setTimeout(resolve, 1500); return; }
			const script = document.createElement('script');
			script.src = 'assets/js/zoho-chat.js';
			script.async = true;
			script.onload = ready;
			script.onerror = () => reject(new Error('Live support is unavailable'));
			document.head.appendChild(script);
		});
		return this.loadPromise;
	}

	async openWithSummary(summary: string, conversationReference: string): Promise<void> {
		try {
			await this.load();
			const salesiq = (window as any).$zoho.salesiq;
			salesiq.visitor.question(summary);
			salesiq.visitor.info({'QwikCut AI Conversation': conversationReference});
			salesiq.chat.start();
		}
		catch (err) {
			await navigator.clipboard?.writeText(summary).catch(() => undefined);
			const button = document.getElementsByClassName('zsiq_floatmain')[0] as HTMLElement;
			if (button) { button.style.display = 'block'; button.click(); }
			throw err;
		}
	}
}
